import React, { useContext, useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import "./CharnedUserModal.css";
import "../../../assets/css/modal.css";
import { dataContext } from "../../../App";
import activityLogSubmission from "../../../helper/activitylog";
import analyticEvent from "../../../helper/gaEvent";
import xImg from "./x.png";
import gift_icon_img from "./gift_icon.png";
import { LuClock3 } from "react-icons/lu";
import { GrCircleQuestion } from "react-icons/gr";
import styles from "./CharnedUserModal.module.css";
import { convertToBengaliNumber } from "./helper";
import { Spinner } from "react-bootstrap";
import { fetchSubscriptionUrl } from "../../../services";
const CharnedUserModal = ({
  showCharnedUserModal,
  setShowCharnedUserModal,
  quizClickHandler,
}) => {
  const { events, playerData,token } = useContext(dataContext);
  const [isLoading, setIsLoading] = useState(false);


  function hideModalOperation() {
    setShowCharnedUserModal(false);
    sessionStorage.removeItem('charnedUserModalType');
  }

  function handleSubscriptionBtn() {
    let serviceType = sessionStorage.getItem('charnedUserModalType')||'Daily';
    setIsLoading(true);
    fetchSubscriptionUrl(token,serviceType).then(res=>{
      activityLogSubmission(`charned-user-modal-subs-clicked-${serviceType}`);
      if(res?.redirectURL){
        sessionStorage.removeItem('charnedUserModalType');
        window.location.replace(`${res?.redirectURL}`);
      }else{
        console.error('Something went wrong. Redirect URL not found',res);
      }
    })
  }

  useEffect(() => {
    activityLogSubmission("charned-user-modal");
    analyticEvent("charned-user-modal", "charned-user-modal-view");
  }, []);

  return (
    <>
      <Modal
        show={showCharnedUserModal}
        centered
        dialogClassName="modal-dialog"
        contentClassName="modalContentCharnedUserModal"
        onHide={hideModalOperation}
      >
        <Modal.Body
          style={{
            // maxHeight: "65vh",
            overflow: "hidden",
            display: "block",
            overflowX: "hidden",
            padding: "6px 20px 0px",
          }}
        >
          <img
            src={xImg}
            alt="logo"
            className={styles.xImg}
            onClick={hideModalOperation}
          />

          <section className={styles.welcomeContainer}>
            <img
              src={gift_icon_img}
              alt="Gift box and coupon illustration"
              className={styles.giftImage}
            />
            <div className={styles.contentWrapper}>
              <div className={styles.cardContent}>
                <h2 className={styles.welcomeTitle}>
                  ওয়েলকাম ব্যাক!
                </h2>
                <p className={styles.welcomeDescription}>
                  <span className={styles.regularText}>
                    ফুল এক্সেস পেতে, র‍্যাঙ্কিংস দেখতে এবং প্রাইজ জিততে এখনই
                    সাবস্ক্রাইব করুন এবং
                  </span>
                  <span className={styles.boldText}> ১০ টাকা ক্যাশ ব্যাক </span>
                  <span className={styles.regularText}>জিতুন!</span>
                </p>
              </div>
              <div className={styles.buttonContainer}>
                <button className={styles.subscribeButton} onClick={handleSubscriptionBtn}>
                  {isLoading ? (
                    <Spinner animation="border" variant="light" size="sm" />
                  ) : (
                    "এখনই সাবস্ক্রাইব করুন!"
                  )}
                </button>
              </div>
            </div>
          </section>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default CharnedUserModal;
